export const storeName = 'idVerifiction';

export const idVerificationSelector = state => ({ ...state[storeName] });
